export function getStyle (props, styles) {
  const { rotateDegrees } = props
  return {
    ...props.style,
    ...props.styles,
    ...styles.rotate(rotateDegrees)
  }
}
